import styled from 'styled-components'

export const ItemsPerPageText = styled.div`  
  color: rgba(32, 32, 32, 0.5);
  display: ${(p) => {
    return p.display
  }};
`

export const ItemsPerPageDropdownWrapper = styled.div`
  height: 32px; 
  border-radius: 4px;
  margin: 0 16px;
`

export const PaginationItemsPerPageWrapper = styled.div`
  display: flex;
  align-items: center;
`
